<template>
  <el-dialog
    title="设置续费价格"
    :visible.sync="show"
    width="600px"
  >
    <div class="remark__content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="手动设置" name="1">
          <el-row>
            <el-col :span="6">设备类型：</el-col>
            <el-col :span="18">
              <el-input size="small" v-model="formData.deviceType" />
            </el-col>
            <el-col :span="6">续费一年价格：</el-col>
            <el-col :span="18">
              <el-input-number size="small" v-model.trim="formData.oneYearPrice" :precision="2" :step="1" />
            </el-col>
            <el-col :span="6">续费两年价格：</el-col>
            <el-col :span="18">
              <el-input-number size="small" v-model.trim="formData.twoYearPrice" :precision="2" :step="1" />
            </el-col>
            <!-- <el-col :span="6">续费三年价格：</el-col>
            <el-col :span="18">
              <el-input-number size="small" v-model.trim="formData.threeYearPrice" :precision="2" :step="1" />
            </el-col> -->
            <el-col :span="6">备注</el-col>
            <el-col :span="18">
              <el-input size="small" v-model="formData.remark" :rows="3" type="textarea" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="上传文件设置" name="2">
          <div class="flex">
            <el-upload
              class="upload"
              action=""
              drag
              :http-request="({ file }) => {}"
              :show-file-list="false"
              :on-change="onChange"
            >
              <div v-if="!file" >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </div>
              <div v-else class="upload-content">
                {{ file.name }}
              </div>
            </el-upload>
            <div class="template" @click="handleExport">
              <span>下载模板</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="type" @click="$emit('update:visible')">取 消</el-button>
      <el-button size="type" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name:"EditRenewalPrice",
  props:{
    visible:{
      type:Boolean,
      default:false
    },
  },
  data(){
    return {
      activeName:'1',
      file:null,
      formData:{
        /**设备类型 */
        deviceType:'',
        /**续费一年价格 */
        oneYearPrice:'',
        /**续费两年价格 */
        twoYearPrice:'',
        /**续费三年价格 */
        threeYearPrice:'',
        /**备注 */
        remark:'',
      }
    }
  },
  computed:{
    show:{
      get(){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible',val);
      }
    },
  },
  watch:{
    visible:{
      handler(val){
        if(val){
          this.init();
        }
      }
    },
  },
  methods:{
    onChange(file){
      this.file = file.raw;
    },
    init(){
      this.activeName = '1';
      this.file = null;
      this.formData = {
        /**设备类型 */
        deviceType:'',
        /**续费一年价格 */
        oneYearPrice:'',
        /**续费两年价格 */
        twoYearPrice:'',
        /**续费三年价格 */
        threeYearPrice:'',
        /**备注 */
        remark:'',
      }
    },
    //下载模板
		handleExport() {
			window.open('/externalSimRenewPrice/downloadUpdateExternalSimRenewPriceTemplate');
		},
    // 备注
    async onConfirm(){
      try{
        if(this.activeName === '1'){
          const { 
            deviceType,
            oneYearPrice,
            twoYearPrice,
            threeYearPrice
          } = this.formData;
          if(!deviceType) throw { msg:'请填写设备类型' };
          if(!oneYearPrice) throw { msg:'请填写续费一年价格' };
          if(!twoYearPrice) throw { msg:'请填写续费两年价格' };
          // if(!threeYearPrice) throw { msg:'请填写续费三年价格' };
          const res = await this.$API.updateExternalSimRenewPriceByDeviceType(this.formData);
          if(res.data.code !== 0) throw { msg:res.data.msg };
          this.$message({
            type:'success',
            message:'成功'
          });
        }else{
          if(!this.file) throw { msg:'请上传文件' };
          let formData = new FormData();
			    formData.append('file', this.file);
          const res = await this.$API.batchUpdateExternalSimRenewPrice(formData);
          console.log(res,'res')
          if(res.data.code !== 0) throw { msg:res.data.msg };
          this.$message({
            type:'success',
            message:'成功'
          });
        }
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$message({
          type:'warning',
          message:msg
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding: 0 20px 10px;
}
::v-deep .el-dialog__footer{
  padding: 0 20px 10px;
}
.remark__content{
  ::v-deep .el-col{
    margin-bottom: 10px;
    line-height: 34px;
    text-align: right;
    .el-input-number{
      width: 100%;
    }
  }
  ::v-deep .el-tabs__item:hover{
    color: #4B88F6;
  }
  ::v-deep .el-tabs__item.is-active{
    color: #4B88F6;
  }
  ::v-deep .el-tabs__active-bar{
    background: #4B88F6;
  }
  .flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
    .upload{
      text-align: center;
      width: 100%;
      ::v-deep .el-upload{
        width: 100%;
        .el-upload-dragger{
          width: 100%;
        }
      }
      .upload-content{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .template{
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
      >span{
        cursor: pointer;
        color: #4B88F6;
      }
    }
  }
}
</style>
